import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c6315322"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "log",
  "active-text-color": "#409EFF",
  "background-color": "#545c64"
};
var _hoisted_2 = {
  style: {
    "margin-left": "10px"
  }
};
var _hoisted_3 = {
  style: {
    "margin-left": "10px"
  }
};
var _hoisted_4 = {
  style: {
    "margin-left": "10px"
  }
};
import srcs from '../../../../../../xmitech_project/xmitech_management/src/assets/R-C.png';
import { computed } from '@vue/reactivity';
import { useStore } from 'vuex';
import svgIcon from '@/components/SvgIcons';
import IconSelect from '@/components/IconSelect';
import { useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var router = useRouter();
    var store = useStore();
    var src = srcs; // 菜单栏收缩隐藏文字

    var display = computed(function () {
      return store.getters.siderType ? 'display:block' : 'display:none';
    });
    var onRoutes = computed(function () {
      if (router.currentRoute.value.meta.activeMenu) {
        return router.currentRoute.value.meta.activeMenu;
      }

      return router.currentRoute.value.path;
    });
    var menusList = computed(function () {
      return store.getters.getMenus;
    });
    return function (_ctx, _cache) {
      var _component_el_image = _resolveComponent("el-image");

      var _component_el_menu_item = _resolveComponent("el-menu-item");

      var _component_el_sub_menu = _resolveComponent("el-sub-menu");

      var _component_el_menu = _resolveComponent("el-menu");

      var _component_el_scrollbar = _resolveComponent("el-scrollbar");

      var _component_el_col = _resolveComponent("el-col");

      var _component_el_row = _resolveComponent("el-row");

      return _openBlock(), _createBlock(_component_el_row, {
        class: "tac"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            style: {
              "height": "100%"
            }
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("template", _hoisted_1, [_createVNode(_component_el_image, {
                class: "imglog",
                src: _unref(src)
              }, null, 8, ["src"]), _createElementVNode("span", {
                class: "logtext",
                style: _normalizeStyle(_unref(display))
              }, "后台管理", 4)]), _createVNode(_component_el_scrollbar, {
                class: "scrollbarel",
                "wrap-class": "scrollbar-wrapper"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_menu, {
                    collapse: !_ctx.$store.getters.siderType,
                    "active-text-color": "#409EFF",
                    "background-color": "#ffffff",
                    "unique-opened": true,
                    class: "el-menu-vertical-demo",
                    "default-active": _unref(onRoutes),
                    router: "",
                    "text-color": "#343333",
                    onOpen: _ctx.handleOpen,
                    onClose: _ctx.handleClose
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_menu_item, {
                        class: "menuitems"
                      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menusList), function (item) {
                        return _openBlock(), _createElementBlock(_Fragment, {
                          key: item.menuId
                        }, [item.children && item.children.length > 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                          key: 0,
                          index: item.menuId
                        }, {
                          title: _withCtx(function () {
                            return [_createVNode(_unref(svgIcon), {
                              style: {
                                "height": "18px",
                                "width": "18px"
                              },
                              "icon-class": item.icon
                            }, null, 8, ["icon-class"]), _createElementVNode("span", _hoisted_2, _toDisplayString(item.menuName), 1)];
                          }),
                          default: _withCtx(function () {
                            return [item.children !== [] ? (_openBlock(true), _createElementBlock(_Fragment, {
                              key: 0
                            }, _renderList(item.children, function (it) {
                              return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
                                key: it.menuId,
                                index: '/' + it.path
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_unref(svgIcon), {
                                    style: {
                                      "height": "18px",
                                      "width": "18px"
                                    },
                                    "icon-class": it.icon
                                  }, null, 8, ["icon-class"]), _createElementVNode("span", _hoisted_3, _toDisplayString(it.menuName), 1)];
                                }),
                                _: 2
                              }, 1032, ["index"])), [[_vShow, it.visible !== "1"]]);
                            }), 128)) : _createCommentVNode("", true)];
                          }),
                          _: 2
                        }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
                          index: '/' + item.path,
                          key: item.menuId
                        }, {
                          default: _withCtx(function () {
                            return [_createVNode(_unref(svgIcon), {
                              style: {
                                "height": "18px",
                                "width": "18px"
                              },
                              "icon-class": item.icon
                            }, null, 8, ["icon-class"]), _createElementVNode("span", _hoisted_4, _toDisplayString(item.menuName), 1)];
                          }),
                          _: 2
                        }, 1032, ["index"]))], 64);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["collapse", "default-active", "onOpen", "onClose"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      });
    };
  }
};